<template>
  <div class="sas-results-section">
    <v-data-table
        v-if="agencies.length > 0"
        :headers="agencyHeaders"
        :items="agencies"
        hide-default-footer
        disable-pagination
        dense
        class="sas-table sas-table-agency"
        @click:row="onAgencyRowClick"
    >
      <template #header.actions>
        <v-chip small :style="chipStyle">Agences</v-chip>
      </template>

      <template #item.actions="{ item }">
        <v-btn icon x-small class="sas-plus-btn" @click.stop="$emit('select-agency', item)">
          <v-icon small>mdi-home-outline</v-icon>
        </v-btn>
      </template>

      <template #item.name="{ item }">
        <span :class="{ 'sas-row-inactive': isInactive(item) }">
          {{ item.name }}
        </span>
      </template>

      <template #item.email="{ item }">
        <span class="caption" :class="{ 'sas-row-inactive': isInactive(item) }">
          {{ item.email }}
        </span>
      </template>

      <template #item.street="{ item }">
        <span :class="{ 'sas-row-inactive': isInactive(item) }">
          {{ item.street }}
        </span>
      </template>

      <template #item.city="{ item }">
        <span :class="{ 'sas-row-inactive': isInactive(item) }">
          {{ item.city }}
        </span>
      </template>

      <template #header.postalcode="{ header }">
        <div class="d-flex align-center fill-height">
          <span>Code</span>
        </div>
      </template>

      <template #item.postalcode="{ item }">
        <span :class="{ 'sas-row-inactive': isInactive(item) }">
          {{ item.postalcode }}
        </span>
      </template>

      <template #item.country="{ item }">
        <span :class="{ 'sas-row-inactive': isInactive(item) }">
          {{ item.country }}
        </span>
      </template>

      <template #item.status="{ item }">
        <AgencyStatusChip x-small :value="item.status"/>
      </template>
    </v-data-table>

    <div v-else class="d-flex align-center pl-4 gap-4">
      <v-chip small :style="chipStyle">Agences</v-chip>
      <slot name="no-result-action" />
      <p class="caption grey--text mb-0">Aucune agence trouvée.</p>
    </div>
  </div>
</template>

<script>
import AgencyStatusChip from "@/components/commons/AgencyStatusChip.vue";

export default {
  name: "SmartAgencySearchResult",
  components: {AgencyStatusChip},
  props: {
    agencies: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["select-agency"],
  computed: {
    agencyHeaders() {
      return [
        { text: "", value: "actions", sortable: false, width: 60, align: "center" },
        { text: "Nom", value: "name" },
        { text: "Email", value: "email" },
        { text: "Rue", value: "street" },
        { text: "Ville", value: "city" },
        { text: "Code postal", value: "postalcode" },
        { text: "Pays", value: "country" },
        { text: "Status", value: "status" },

      ]
    },
    chipStyle() {
      return {
        backgroundColor: "#B2EBF2",
        color: "#00838F",
      }
    },
  },
  methods: {
    isInactive(item) {
      return item.status !== "validated"
    },
    onAgencyRowClick(item) {
      this.$emit("select-agency", item)
    },
  },
}
</script>

<style scoped>
.sas-results-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sas-table {
  font-size: 12px;
  cursor: pointer;
}

.sas-row-inactive {
  opacity: 0.5;
}

.sas-table ::v-deep tbody tr:hover {
  background-color: transparent !important;
  cursor: pointer;
}

.sas-table-agency ::v-deep tbody tr:hover td {
  color: #00838F !important;
}

.sas-table-agency ::v-deep tbody tr:hover .sas-plus-btn {
  border-color: #00838F !important;
  background-color: #B2EBF2;
}

.sas-plus-btn {
  width: 24px;
  height: 24px;
  min-width: 24px !important;
  border-radius: 999px;
  border: 1px solid #dadce0;
}
.gap-4 {
  gap: 16px;
}
</style>